/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Table_Header_Data_CategoriesInputs */

const en_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Categories`)
};

const de_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenkategorien`)
};

const fr_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories de donnees`)
};

const es_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorias de datos`)
};

const it_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie di dati`)
};

const nl_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevenscategorieën`)
};

const pl_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie danych`)
};

const fi_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoluokat`)
};

const da_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datakategorier`)
};

const sv_privacy_table_header_data_categories = /** @type {(inputs: Privacy_Table_Header_Data_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datakategorier`)
};

/**
* | output |
* | --- |
* | "Data Categories" |
*
* @param {Privacy_Table_Header_Data_CategoriesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_table_header_data_categories = /** @type {((inputs?: Privacy_Table_Header_Data_CategoriesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Table_Header_Data_CategoriesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_table_header_data_categories(inputs)
	if (locale === "fr") return fr_privacy_table_header_data_categories(inputs)
	if (locale === "es") return es_privacy_table_header_data_categories(inputs)
	if (locale === "it") return it_privacy_table_header_data_categories(inputs)
	if (locale === "nl") return nl_privacy_table_header_data_categories(inputs)
	if (locale === "pl") return pl_privacy_table_header_data_categories(inputs)
	if (locale === "fi") return fi_privacy_table_header_data_categories(inputs)
	if (locale === "da") return da_privacy_table_header_data_categories(inputs)
	if (locale === "sv") return sv_privacy_table_header_data_categories(inputs)
	return en_privacy_table_header_data_categories(inputs)
});